// JS
import 'bootstrap/js/dist/collapse';

import './js/journeys/book-an-appointment-referral/main.js';


// Images

import './img/journeys/book-an-appointment/dental-profession.svg';
import './img/journeys/book-an-appointment/education-profession.svg';
import './img/journeys/book-an-appointment/gp-profession.svg';
import './img/journeys/book-an-appointment/hospital-profession.svg';
import './img/journeys/book-an-appointment/other-profession.svg';